import PaymentChip from "../../components/Payments/PaymentChip";
const DashboardActiveProjectsColumns = ({ isMobile }) => [
    {
        field: "name",
        headerName: "Name",
        flex: 1,
        renderCell: ({ row: { _id, name } }) => (
            <a className="hive-dashboard-opps-link" href={`/opportunities/${_id}`}>{name}</a>
        ),
    },
    ...(isMobile ? [] : [
        {
            field: "projectNumber",
            headerName: "Project #",
            flex: 1,
        },
        {
            field: "quoteNumber",
            headerName: "Quote #",
            flex: 1,
        },
        {
            field: "customer",
            headerName: "Customer",
            flex: 1,
            renderCell: ({ row: { customer } }) => customer?.organizationName || "",
            valueGetter: (params) => params?.organizationName || "",
        },
        {
            field: "owner",
            headerName: "Owner",
            flex: 1,
            renderCell: ({ row: { owner } }) => owner ? `${owner.firstName} ${owner.lastName}` : "Unassigned",
            valueGetter: (params) => params ? `${params.firstName || ""} ${params.lastName || ""}`.trim() : "Unassigned",
        },
        {
            field: "projectManager",
            headerName: "Project Manager",
            flex: 1,
            renderCell: ({ row: { projectManager } }) => projectManager || "",
        },
        {
            field: "total",
            headerName: "Total",
            flex: 1,
            renderCell: ({ row: { total } }) => new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(total || 0),
        },
        {
            field: "earliestShipDate",
            headerName: "Earliest Ship Date",
            flex: 1,
            renderCell: ({ row: { earliestShipDate } }) => earliestShipDate ? earliestShipDate.split("T")[0] : "",
        },
        {
            field: "paymentStatus",
            headerName: "Payment Status",
            renderCell: ({ value }) => <PaymentChip status={value || "Not paid"} />,
            flex: 1,
        },
    ]),
    ...(isMobile ? [{ field: "paymentStatus", headerName: "Payment Status", minWidth: 160, renderCell: ({ value }) => <PaymentChip status={value || "Not paid"} /> }] : []),
    {
        field: "salesStage",
        headerName: "Stage",
        flex: 1,
        renderCell: ({ row: { salesStage } }) => (
            <label className={`badge  ${salesStage === '01 - Lead' ? 'bg-light-primary' : salesStage === '08 - Won' ? 'bg-light-success' : salesStage === '05 - Committee Approval' ? 'bg-light-warning' : salesStage === '04 - Internal Revision' ? 'bg-light-danger' : salesStage === '06 - Quote Sent' ? 'bg-light-primary' : salesStage === '02 - Identified' ? 'bg-light-dark' : salesStage === '03 - Committee' ? 'bg-light-secondary' : salesStage === "07 - External Revision" ? 'bg-light-danger' : 'bg-light-info'}`} style={{ minHeight: '75%', minWidth: '75%', padding: "0", lineHeight: '3', fontSize: '14px' }}>{salesStage}</label>
        ),
    },
];

export default DashboardActiveProjectsColumns;
